import React, { useState, useEffect } from "react";
import CheckboxTree from "react-checkbox-tree";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import { post, get } from "../../services/api"; // Your API service

const RolePermissionList = () => {
  const token = localStorage.getItem("token");

  const [checked, setChecked] = useState([]);
  const [expanded, setExpanded] = useState([]);
  const [nodes, setNodes] = useState([]);
  const [selectedRoleId, setSelectedRoleId] = useState("");
  const [roleData, setRoleData] = useState([]); // State for categories

  // Function to fetch categories from API
  const getRoles = async () => {
    if (!token) return;
    try {
      const response = await get("Role", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setRoleData(response); // Assuming response.navCategory contains the roles
    } catch (error) {
      console.error("Error fetching Roles:", error);
    }
  };
  // Function to send permissions to the server
  const sendPermissionsToServer = async () => {
    if (!selectedRoleId) {
      alert("Please select a role first.");
      return;
    }

    const transformedData = nodes.map((category) => ({
      Value: category.value,
      Label: category.label,
      Status: checked.includes(category.value) ? "true" : "false",
      SubCategories: category.children.map((subCategory) => ({
        Value: subCategory.value,
        Label: subCategory.label,
        Status: checked.includes(subCategory.value) ? "true" : "false",
        Forms: subCategory.children.map((form) => ({
          Value: form.value,
          Label: form.label,
          Status: checked.includes(form.value) ? "true" : "false",
          Permissions: form.children.map((permission) => ({
            Value: permission.value,
            Label: permission.label,
            Status: checked.includes(permission.value) ? "true" : "false",
          })),
        })),
      })),
    }));
    try {
      const response = await post(
        "UserAuthentication/SaveRolePermission",
        {
          RoleId: selectedRoleId,
          Category: transformedData,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.isSuccess) {
        alert("Permissions saved successfully!");
      } else {
        console.error("Error saving permissions:", response.message);
      }
    } catch (error) {
      console.error("Error sending permissions:", error);
    }
  };

  useEffect(() => {
    getRoles(); // Fetch categories when the component mounts
  }, [token]);

  useEffect(() => {
    if (selectedRoleId) {
      const fetchRolePermissions = async () => {
        try {
          const formData = { id: selectedRoleId };

          const response = await post(
            `UserAuthentication/GetRolePermission`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          if (response.isSuccess) {
            const { rolePermission } = response;

            // Transform the response into the format needed for CheckboxTree
            const transformedNodes = transformPermissions(rolePermission);
            setNodes(transformedNodes);
            const getCheckedValues = (nodes) => {
              // console.log(nodes);
              return nodes.flatMap((node) => {
                const checkedChildren = getCheckedValues(node.children || []);
                return node.status
                  ? [node.value, ...checkedChildren]
                  : checkedChildren;
              });
            };

            const checkedValues = getCheckedValues(transformedNodes);
            setChecked(checkedValues);
          } else {
            console.error(
              "Failed to fetch role permissions:",
              response.message
            );
            setNodes([]); // Clear nodes if the fetch failed
          }
        } catch (error) {
          console.error("Error fetching role permissions:", error);
        }
      };

      fetchRolePermissions();
    } else {
      setNodes([]);
    }
  }, [selectedRoleId]);

  const transformPermissions = (permissionData) => {
    if (!permissionData || !permissionData.children) return [];
    return permissionData.children.map((category, catIndex) => ({
      value: `cat-${catIndex}-${category.value}`,
      label: category.label,
      status: category.status, // Default to false if status is undefined
      children:
        category.children?.map((subCategory, subCatIndex) => ({
          value: `subCat-${catIndex}-${subCatIndex}-${subCategory.value}`,
          label: subCategory.label,
          status: subCategory.status,
          children:
            subCategory.children?.map((form, formIndex) => ({
              value: `form-${catIndex}-${subCatIndex}-${formIndex}-${form.value}`,
              label: form.label,
              status: form.status,
              children:
                form.children?.map((permission, permIndex) => ({
                  value: `per-${catIndex}-${subCatIndex}-${formIndex}-${permIndex}-${permission.value}`,
                  label: permission.label,
                  status: permission.status,
                })) || [],
            })) || [],
        })) || [],
    }));
  };

  return (
    <div className="container">
      <div className="row mb-3">
        <div className="col-md-3">
          <label htmlFor="categorySelect">Select Role:</label>
          <select
            id="categorySelect"
            value={selectedRoleId}
            className="form-control"
            onChange={(e) => setSelectedRoleId(e.target.value)}
          >
            <option value="">--Select Role--</option>
            {roleData.map((category) => (
              <option key={category.id} value={category.id}>
                {category.name}
              </option>
            ))}
          </select>
        </div>
      </div>
      {nodes.length > 0 ? (
        <CheckboxTree
          nodes={nodes}
          checked={checked}
          expanded={expanded}
          onCheck={(checked) => setChecked(checked)}
          onExpand={(expanded) => setExpanded(expanded)}
          iconsClass="fa5"
        />
      ) : (
        <div className="text-center mt-3">
          <p>No permissions available for the selected role.</p>
        </div>
      )}
      <button
        onClick={sendPermissionsToServer}
        className="btn btn-primary mt-3"
      >
        Save Permissions
      </button>
    </div>
  );
};

export default RolePermissionList;
